import React from "react"
import styled from "styled-components"
import CloseIcon from "../common/components/icons/CloseIcon"
import Icon from "../../static/images/app_icons/ios-icon-192x192.png"
import { Paragraph, RoundButton } from "buoy-core"
import { connect } from "react-redux"
import PopUpContainer from "../feedback/components/postIntent/components/PopUpContainer"
import { SVG_URL } from "../common/constants"

const Container = styled(PopUpContainer)`
  padding-top: 24px;
  color: #fff;
  min-height: 375px;
  box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.5);
  background-color: #196cff;
  border: none;
`

const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
`

const AppIcon = styled.div`
  width: 50px;
  height: 50px;
  border-radius: 8px;
  display: inline-block;
  background-size: cover;
  background-position: center;
  background-image: url(${Icon});
`

const HeaderContainer = styled.div`
  margin-bottom: 10px;
`

const Header = styled.h1`
  font-size: 20px;
  font-weight: 400;
  max-width: 200px;
  bottom: 5px;
  margin-left: 14px;
  display: inline-block;
  position: relative;
  font-style: normal;
  line-height: 1.25;
  letter-spacing: 0.3px;
`

const Description = styled(Paragraph)`
  max-width: 420px;
  color: #fff;
`

const Instructions = styled.div`
  margin-top: 16px;
  font-size: 16px;
  letter-spacing: 0.3px;
  font-weight: 300;
  color: #fff;
`

const ShareIcon = styled.div`
  top: 4px;
  width: 15px;
  height: 20px;
  position: relative;
  display: inline-block;
  background-size: cover;
  background-position: center;
  background-image: url(${SVG_URL}share.svg);
`

const InstalliOS = ({ isChrome }) => (
  <React.Fragment>
    {isChrome ? (
      <div>To install, please visit this page in Safari.</div>
    ) : (
      <div>
        Just tap <ShareIcon /> then 'Add to Home Screen'
      </div>
    )}
  </React.Fragment>
)

const InstallButton = styled(RoundButton)`
  margin-top: 0;
`

const InstallAndroid = ({ dismissBanner }) => (
  <React.Fragment>
    {window.deferredInstallPrompt ? (
      <InstallButton
        color="neutralLightest"
        textColor="primary"
        onClick={() => {
          window.deferredInstallPrompt.prompt()
          dismissBanner()
        }}
      >
        Add to Home Screen
      </InstallButton>
    ) : (
      <div>To install, please visit this page in Chrome.</div>
    )}
  </React.Fragment>
)

const InstallBanner = ({ isApple, isChromeiOS, dismissBanner }) => (
  <Container>
    <CloseIcon onClick={() => dismissBanner()} color="#96cdff" />
    <ContentContainer>
      <HeaderContainer>
        <AppIcon />
        <Header>Download Buoy Health Assistant</Header>
      </HeaderContainer>
      <Description>
        Add to your home screen for easy access the next time you're sick,
        injured or want to use your health benefits.
      </Description>
      <Instructions>
        {isApple ? (
          <InstalliOS isChrome={isChromeiOS} />
        ) : (
          <InstallAndroid dismissBanner={dismissBanner} />
        )}
      </Instructions>
    </ContentContainer>
  </Container>
)

class InstallBannerContainer extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      show: false,
      dismissed: false,
    }
    this.dismissBanner = this.dismissBanner.bind(this)
  }

  componentDidUpdate() {
    const bannerDismissed = window.localStorage.getItem("PWA BANNER DISMISSED")
    if (
      !this.state.show &&
      this.props.viewedCookiePolicy &&
      !this.state.dismissed &&
      !bannerDismissed
    ) {
      setTimeout(() => {
        this.setState({ show: true })
      }, 30000)
    }
  }

  dismissBanner() {
    this.setState({ show: false, dismissed: true })
    window.localStorage.setItem("PWA BANNER DISMISSED", "true")
  }

  render() {
    const userAgent = navigator.userAgent.toLowerCase()
    const isApple = userAgent.includes("iphone") || userAgent.includes("ipad")
    const isAndroid = userAgent.includes("android")
    const isMobile = isApple || isAndroid
    const isChromeiOS = userAgent.includes("crios")
    const isPWA = window.matchMedia("(display-mode: standalone)").matches
    const show = isMobile && !isPWA && this.state.show

    return show ? (
      <InstallBanner
        isApple={isApple}
        isChromeiOS={isChromeiOS}
        dismissBanner={this.dismissBanner}
      />
    ) : null
  }
}

const mapStateToProps = state => ({
  viewedCookiePolicy: state.auth.viewedCookiePolicy,
})

const InstallBannerContainerWrapper = connect(mapStateToProps)(
  InstallBannerContainer
)

export { InstallBannerContainerWrapper as default }



// WEBPACK FOOTER //
// ./assets/modals/PWAInstallBanner.js